import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-login-redirect',
  templateUrl: './login-redirect.component.html',
  styleUrls: ['./login-redirect.component.css']
})
export class LoginRedirectComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    const sessionKey = 'Estate-Map.LoginRedirect';
    const session = window.sessionStorage.getItem(sessionKey);
    if (session) {
      if (window.opener) {
        window.opener.postMessage('login successfully', window.location.origin);
        window.close();
      }
    } else {
      window.sessionStorage.setItem(sessionKey, 'login');
      window.location.href = '/signin?redirect=' + encodeURIComponent(window.location.pathname + window.location.search);
    }
  }

}
